import AgentLayout from 'features/agent/components/AgentLayout';

import { Navigate, Route, Routes } from 'react-router-dom';
import { PAYMENT_REQUEST_HOSTORY_ROUTES } from './routes';
import Dashboard from './dashboard';
export default function PaymentRequestHistory() {
  return (
    <Routes>
      <Route element={<AgentLayout />}>
        <Route index element={<Navigate replace to={PAYMENT_REQUEST_HOSTORY_ROUTES.index.to} />} />
        <Route path={PAYMENT_REQUEST_HOSTORY_ROUTES.dashboard.path} element={<Dashboard />} />
      </Route>
    </Routes>
  );
}
